import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Footer from '../components/footer';
import UnifiedCommunications from '../components/unifiedCommunication';
function UnifiedCommunicationsPage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <UnifiedCommunications />
        <Footer />
      </div>
    );
  }

 export default UnifiedCommunicationsPage; 
  
  